import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

class Button extends Component {
  render() {
    const {
      onClick,
      header,
      loading,
      style,
      className = 'confirm_button'
    } = this.props

    return (
      <div
        className={className}
        onClick={() => {
          if (!loading) onClick()
        }}
        style={{
          marginTop: 25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 44,
          ...style
        }}
      >
        {loading ? (
          <CircularProgress
            style={{ color: 'white' }}
            thickness={6}
            size={20}
          />
        ) : (
          header
        )}
      </div>
    )
  }
}

export { Button }



// WEBPACK FOOTER //
// ./src/components/common/Button.js